import { Avatar as pAvatar } from 'primeng/avatar';

import { input, computed, Component, InputSignal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { AvatarSize, AvatarShape } from './types';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.html',
  styleUrl: './avatar.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'avatar',
    '[class]': '[shape(), size()]',
  },
  imports: [pAvatar],
})
export class Avatar {
  public text: InputSignal<string | undefined> = input<string | undefined>();

  public image: InputSignal<string | undefined> = input<string | undefined>(undefined);

  public defaultPicture: InputSignal<string | undefined> = input<string | undefined>(undefined);

  public shape: InputSignal<AvatarShape> = input<AvatarShape>('circle');

  public size: InputSignal<AvatarSize> = input<AvatarSize>('normal');

  public id: InputSignal<number | string | undefined> = input<number | string | undefined>(1);

  protected label = computed(() => {
    if (this.image() || this.defaultPicture()) {
      return undefined;
    }

    const words = this.text()?.trim().split(/\s+/);

    if (!words) {
      return undefined;
    }

    if (words.length >= 2) {
      return Array.from(words[0])[0] + Array.from(words[1])[0];
    }

    const firstWordChars = Array.from(words[0]);
    return firstWordChars.slice(0, 2).join('');
  });

  getColor(id?: number | string): string {
    const colors = ['#7674EE', '#E9624E', '#4DCBDC', '#F6BF26'];

    if (id === undefined || id === null) {
      return colors[0];
    }
    const index = typeof id === 'number' ? id : this.hashString(id);

    return colors[Math.abs(index) % colors.length];
  }

  private hashString(value: string): number {
    let hash = 0;

    for (let i = 0; i < value.length; i++) {
      hash = value.charCodeAt(i) + ((hash << 5) - hash);
    }

    return hash;
  }

  protected choseImage = computed(() => {
    if (this.image()) {
      return this.image();
    }
    const defaultPicture = this.defaultPicture();
    if (defaultPicture) {
      return 'assets/images/' + defaultPicture;
    }
    return undefined;
  });
}
